import {
  HealthToolCardWrapper,
  HealthToolCardWrapperProps,
} from '@hhgtech/hhg-components'

import AirPopulation from '../AirPopulation'
import { AirPopulationProps } from '../AirPopulation/Container'

type Props = {
  formProps?: AirPopulationProps
  cardProps?: HealthToolCardWrapperProps
}

export const AirPopulationEmbedCard = ({ formProps, cardProps }: Props) => {
  return (
    <AirPopulation {...formProps}>
      {({ cardInfo }) => (
        <HealthToolCardWrapper {...cardProps}>
          <HealthToolCardWrapper.Banner
            isRevamp
            icon={
              <img
                alt="health-tool-icon"
                src={cardInfo?.featuredImage}
                loading="lazy"
              />
            }
            medicalReview={undefined}
            heading={cardInfo?.title || ''}
            disclaimer={cardInfo?.disclaimer || ''}
          />
          <HealthToolCardWrapper.Body
            sx={(theme) => ({
              padding: '24px 16px',
              [theme.fn.largerThan('sm')]: { padding: '40px 48px' },
            })}
          >
            <AirPopulation.Body />
          </HealthToolCardWrapper.Body>
        </HealthToolCardWrapper>
      )}
    </AirPopulation>
  )
}
